import { defineMessages } from 'react-intl'

const scope = 'app.components.BusinessReviews'

export default defineMessages({
  totalRevenue: {
    id: `${scope}.totalRevenue`,
    defaultMessage: 'Total Documented Revenue: ',
  },
  option: {
    id: `${scope}.option`,
    defaultMessage: '{label} ({count})',
  },
})
